var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('LogoMark',{staticClass:"loading-panel__logo"}),_c('p',[_vm._v("Loading…")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }